var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRpm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#E3F0FC"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 27)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4994EC",
    fillRule: "nonzero",
    d: "M35.066.916a2.884 2.884 0 0 0-2.116-.88H2.995c-.823 0-1.528.293-2.115.88A2.884 2.884 0 0 0 0 3.03v20.37c0 .824.293 1.528.88 2.115.587.587 1.292.88 2.115.88H13.18c0 .474-.1.961-.3 1.46-.199.5-.399.936-.598 1.31-.2.375-.3.65-.3.824 0 .324.119.606.356.842.237.238.518.357.842.357h9.586c.324 0 .605-.119.842-.357a1.15 1.15 0 0 0 .356-.842c0-.162-.1-.433-.3-.814-.2-.38-.4-.824-.599-1.329-.2-.506-.3-.99-.3-1.451h10.186c.823 0 1.528-.293 2.115-.88.586-.586.88-1.291.88-2.115V3.03c0-.824-.294-1.529-.88-2.115zm-1.517 17.692c0 .162-.059.302-.177.421a.577.577 0 0 1-.422.177H2.995a.576.576 0 0 1-.42-.177.577.577 0 0 1-.179-.421V3.03c0-.162.06-.302.178-.421a.577.577 0 0 1 .421-.178h29.956c.162 0 .302.06.42.178a.576.576 0 0 1 .178.421v15.577z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 2,
    x: 4,
    y: 5,
    fill: "#78B3F0",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 2,
    x: 4,
    y: 9,
    fill: "#78B3F0",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 2,
    x: 4,
    y: 13,
    fill: "#78B3F0",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 12,
    x: 23,
    y: 5,
    fill: "#78B3F0",
    rx: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRpm);
export default __webpack_public_path__ + "static/media/ic-rpm.7578d70f08978f53c535a611e6549477.svg";
export { ForwardRef as ReactComponent };